module.exports = __webpack_public_path__ + "img/icon_white_sticker.ca97d4bb.png";